import { Link } from "react-router-dom";
import { PageHero } from "@/night/ui";

export default function NotFound() {
  return (
    <PageHero en="404" ar="ضعت في لوس سانتوس" desc="الصفحة مو موجودة، يمكن الرابط غلط.">
      <Link to="/" className="btn-ice mt-10" data-testid="notfound-home-btn">ارجع للرئيسية</Link>
    </PageHero>
  );
}
